/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AbstractService} from './abstract.service';
import {Atm} from '../_models/atm';
import {AND, EQ} from '../_enums/operators';
import {DEFAULT, EMBEDDED} from '../_enums/serializer-groups';

@Injectable()
export class AtmService extends AbstractService<Atm> {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(@Inject(LOCALE_ID) public locale: string, protected httpClient: HttpClient) {
    super(locale, httpClient, 'atm', 'atms');
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                                                                GET                                                                 ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public getDefault(): Observable<Atm | null> {
    return new Observable((observer) => {
      this.find({
        filter: [['enabled', EQ, true], AND, ['default', EQ, true]],
        serializerGroups: [DEFAULT, EMBEDDED]
      }).subscribe((res: HttpResponse<Atm[]>) => {
        observer.next((0 < res.body.length) ? res.body[0] : null);
      }, (err: HttpErrorResponse) => {
        observer.error(err);
      });
    });
  }

}
